export const ConfPublications = [
  {
    id: 'reliancescope',
    title: 'RelianceScope: An Analytical Framework for Examining Students\' Reliance on Generative AI Chatbots in Problem Solving',
    authors: ['hyoungwook', 'minju', 'jieun', 'zixin', 'soyeon', 'xu'],
    year: 2026,
    venue: 'L@S',
    award: 'Best Paper',
    urls: {
      paper: 'https://dl.acm.org/doi/10.1145/3774398.3811612',
      arxiv: 'https://arxiv.org/abs/2602.16251',
      website: 'https://jhw123.github.io/project/reliancescope',
    },
  },
  {
    id: 'teachtune',
    title: 'TeachTune: Reviewing Pedagogical Agents Against Diverse Student Profiles with Simulated Students',
    authors: ['hyoungwook', 'minju', 'jeongeon', 'Yokyung Lee', 'xu', 'juho'],
    year: 2025,
    venue: 'CHI',
    urls: {
      paper: 'https://dl.acm.org/doi/10.1145/3706598.3714054',
      arxiv: 'https://arxiv.org/abs/2410.04078v3',
      website: 'https://teachtune.kixlab.org/',
    },
  },
];

export const WorkPublications = [
  {
    id: 'ailit',
    title: 'Toward Critical AI Literacy: Embedded Assessment of Students’ Critical Engagement with LLM Responses',
    authors: ['minju', 'Junghee Hwang'],
    equalContribution: ['minju', 'Junghee Hwang'],
    note: 'ALIT4ALL: 2nd International Workshop on AI Literacy Education For All, In conjunction with the Festival of Learning 2026 @ AIED, Seoul, Korea\n(Poster track)',
    year: 2026,
    urls: {
      paper: 'https://drive.google.com/file/d/1eBcZh8QWNiVI55wYnY7mzyMXGcETkcCX/view?usp=sharing',
    },
  },
  {
    id: 'mindful',
    title: 'Conversational AI Meets Mindfulness: Exploring LLMs as a Socio‑Emotional Layer in a Math Intelligent Tutoring System',
    authors: ['Vera Rief', 'Mirella Hladký', 'minju', 'Stephanie Heel', 'Shintaro Sato', 'tomo'],
    venue: 'Proceedings of the 21st European Conference on Technology Enhanced Learning (EC-TEL2026)',
    year: 2026,
    note: 'Short Paper (To appear)',
    // urls: {
    //   arxiv: '',
    // },
  },
  {
    id: 'protoflow',
    title: 'Supporting Design Reasoning in AI-assisted Interface Prototyping for HCI Research',
    authors: ['grace', 'minju', 'jenny', 'daeun'],
    equalContribution: ['grace', 'minju'],
    venue: 'CHI',
    year: 2026,
    note: 'Poster',
    urls: {
      paper: 'https://dl.acm.org/doi/10.1145/3772363.3798883',
    },
  },
  {
    id: 'teachcraft',
    title: 'How Do Teachers Create Pedagogical Chatbots?: Current Practices and Challenges',
    authors: ['minju', 'hyoungwook', 'juho'],
    year: 2025,
    note: 'CHI 2025 Workshop: Augmented Educators and AI',
    urls: {
      arxiv: 'https://arxiv.org/abs/2503.00967',
    },
  },
  {
    id: 'beyond',
    title: 'Beyond Tools: Understanding How Heavy Users Integrate LLMs into Everyday Tasks and Decision-Making',
    authors: ['grace', 'kiroong', 'minju', 'sadat', 'jinwook'],
    year: 2025,
    note: 'CHI 2025 Workshop: Tools for Thought',
    urls: {
      arxiv: 'https://arxiv.org/abs/2502.15395',
    },
  },
];